/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_7_DInputs */

const en_tut_part_7_d = /** @type {(inputs: Tut_Part_7_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance, cost, and plans.`)
};

const id_tut_part_7_d = /** @type {(inputs: Tut_Part_7_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilan, biaya, dan paket.`)
};

/**
* | output |
* | --- |
* | "Appearance, cost, and plans." |
*
* @param {Tut_Part_7_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_7_d = /** @type {((inputs?: Tut_Part_7_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_7_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_7_d(inputs)
	return en_tut_part_7_d(inputs)
});